import { render, staticRenderFns } from "./MarketingMailTemplate.vue?vue&type=template&id=34c543ef&scoped=true&"
import script from "./MarketingMailTemplate.vue?vue&type=script&lang=js&"
export * from "./MarketingMailTemplate.vue?vue&type=script&lang=js&"
import style0 from "./MarketingMailTemplate.vue?vue&type=style&index=0&id=34c543ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c543ef",
  null
  
)

export default component.exports